var ItemListView = (function (BaseView, ItemView) {
    return BaseView.extend({
        el: '@itemListContainer',

        initialize: function () {
            _.bindAll(this, '_renderItem');
            this.listenTo(this.collection, 'add', this._renderItem);
        },

        render: function () {
            var rendered = [];
            this.collection.each(_.bind(function (model) {
                rendered.push(this._initItemView(model).render().el);
            }, this));
            this.$el.html(rendered);
        },

        _initItemView: function (model) {
            this.$el.toggleClass('hidden-block', (this.collection._display !== true));
            return new ItemView({ model: model, removeFromCartPixel: this.options.removeFromCartPixel });
        },

        _renderItem: function (model) {
            this.$el.append(this._initItemView(model).render().el);
        }
    });
})(BaseView, ItemView);

var ShipmentsListView = (function (ItemListView) {

    var ShipmentView = Backbone.View.extend({
        initialize: function (data) {
            _.bindAll(this, '_render', '_destroy');
            this._deliveryOptions = data.deliveryOptions;
            this.model.on('change', this._render);
            this.model.on('remove', this._destroy);
            this._render();
        },

        _render: function () {
            var data = this.model.toJSON();
            data.SelectStatus = this._deliveryOptions.getOurpaySelectStatus();
            data.WarningMessage = this._getWarningMessage(data);
            this.$el.html($.tmpl('bt-checkout-shipment', data));
            this.$itemsList = this.$('@shipmentItemsList');
            this.itemsView = new ItemListView({ el: this.$itemsList, collection: this.model.get('Items'), removeFromCartPixel: this.options.removeFromCartPixel});
            this.itemsView.render();
        },

        _destroy: function () {
            this.undelegateEvents();
            this.$el.removeData().unbind();
            this.remove();
            Backbone.View.prototype.remove.call(this);
        },

        _getWarningMessage: function (data) {
            var message = kos.getPageTemplate('_ImpossibleToDeliverAtLocation');
            if (data.MinimumDeliveryPriceThreshold) {
                var amount = toMoney(data.MinimumDeliveryPriceThreshold, GlobalSettings.CurrencySign);
                message = kos.getPageTemplate('_ShippingMinimumOrderValue').replace('[0]', amount);
            }
            return message;
        },
    });

    var ShipmentsListView = Backbone.View.extend({
        el: '@shipmentsListContainer',
        initialize: function (data) {
            _.bindAll(this, '_renderShipment');
            this._deliveryOptions = data.deliveryOptions;
            this.collection.on('add', this._renderShipment);
            this.removeFromCartPixel = data.removeFromCartPixel;
        },
        _renderShipment: function (model) {
            this.$el.toggleClass('hidden-block', (this.collection._display !== true));
            var item = new ShipmentView({ model: model, deliveryOptions: this._deliveryOptions, removeFromCartPixel: this.removeFromCartPixel});
            this.$el.append(item.$el);
        }
    });

    return ShipmentsListView;
})(ItemListView);